var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedesignLogtipoBranco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.9 80.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.71,
    y: 42.49,
    width: 16.48,
    height: 37.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.71,
    y: 21.03,
    width: 37.61,
    height: 16.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 42.56,
    width: 37.61,
    height: 16.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.24,
    width: 16.48,
    height: 37.61
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.13 58.96 102.77 58.96 104.95 37.3 111.02 58.96 119.15 58.96 125.11 37.3 127.52 58.96 140.81 58.96 134.72 21.03 120.76 21.03 115.26 41.43 109.99 21.03 95.66 21.03 89.13 58.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.33,21.03h-15.37l-13.52,37.93h14.9l.92-4.58h10.77l1.03,4.58h14.67l-13.39-37.93Zm-10.9,24.41l3.15-12.83,2.81,12.83h-5.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.54 58.96 187.9 58.96 187.9 21.03 213.34 21.03 213.34 31.23 201.65 31.23 201.65 35.47 212.31 35.47 212.31 45.44 201.65 45.44 201.54 58.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 218.26,
    y: 21.03,
    width: 14.09,
    height: 37.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.01,43.49s7.22-.47,7.22-10.31c0-12.83-14.84-12.15-14.84-12.15h-17.59v37.93h13.41v-12.03l6.53,12.03h15.24l-9.97-15.47Zm-12.03-5.39v-7.45s6.42-.8,6.42,3.72-6.42,3.72-6.42,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m296.78,19.73c-11.25,0-20.36,9.05-20.36,20.2s9.12,20.2,20.36,20.2,20.36-9.05,20.36-20.2-9.12-20.2-20.36-20.2Zm-.04,27.8c-3.67,0-6.65-3.31-6.65-7.4s2.98-7.4,6.65-7.4,6.65,3.31,6.65,7.4-2.98,7.4-6.65,7.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "323.01 58.96 349.9 58.96 349.9 46.55 336.46 46.55 336.46 21.03 323.01 21.03 323.01 58.96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedesignLogtipoBranco);
export default __webpack_public_path__ + "static/media/Redesign_Logótipo_(branco).365406b33901065a1da3d07e86f955f4.svg";
export { ForwardRef as ReactComponent };